export default __webpack_public_path__ + "static/media/22_mobile.709c2332.jpg";